<template>
  <div id="app">
    <street-view-map />
  </div>
</template>

<script>
import StreetViewMap from './components/Map'

export default {
  name: 'app',
  components: {
    StreetViewMap
  }
}
</script>

<style>
body, html {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  background: #2c3e50;
  color:#FFF;
}
html {
  box-sizing: border-box;
}

*, *:before, *:after {
  box-sizing: inherit;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #FFF;
  padding:0px;
  margin:0px auto;
  display: flex;
  width:100%;
  height:100%;
  max-width: 1000px;
}

</style>



// WEBPACK FOOTER //
// App.vue?3a8b0cf2